import React from 'react';
import { Container, Typography, Box, Paper, Grid } from '@mui/material';
import { Assessment as AssessmentIcon } from '@mui/icons-material';

const MaturityAssessment: React.FC = () => {
  const dimensions = [
    { name: 'Data Governance', current: 3, target: 4 },
    { name: 'Data Quality', current: 3, target: 5 },
    { name: 'Metadata Management', current: 2, target: 4 },
    { name: 'Data Architecture', current: 3, target: 4 },
    { name: 'Data Security', current: 4, target: 5 },
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: 'primary.main', mb: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          <AssessmentIcon sx={{ fontSize: 40 }} />
          Maturity Assessment
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Evaluate and track data governance maturity
        </Typography>
      </Box>

      <Paper sx={{ p: 3, mb: 3, background: 'linear-gradient(135deg, #0055AA 0%, #0066CC 100%)', color: 'white' }}>
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: 'white' }}>Overall Maturity Level</Typography>
        <Typography variant="h2" sx={{ fontWeight: 700, color: 'white' }}>Level 3</Typography>
        <Typography variant="body2" sx={{ color: 'white' }}>Defined & Managed</Typography>
      </Paper>

      <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
        Maturity by Dimension
      </Typography>
      <Grid container spacing={2}>
        {dimensions.map((dim, index) => (
          <Grid item xs={12} key={index}>
            <Paper sx={{ p: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>{dim.name}</Typography>
                <Typography variant="body2" color="text.secondary">
                  Current: Level {dim.current} → Target: Level {dim.target}
                </Typography>
              </Box>
              <Box sx={{ width: '100%', height: 8, bgcolor: 'divider', borderRadius: 1, overflow: 'hidden' }}>
                <Box sx={{ width: `${(dim.current / 5) * 100}%`, height: '100%', bgcolor: 'primary.main', transition: 'width 0.3s' }} />
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Paper sx={{ p: 4, mt: 3, textAlign: 'center', background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)', border: '2px dashed #003366' }}>
        <Typography variant="h5" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
          🚧 Maturity Assessment Tool Coming Soon
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Features: Self-assessment surveys, Benchmarking, Gap analysis, Improvement roadmaps.
        </Typography>
      </Paper>
    </Container>
  );
};

export default MaturityAssessment;
